import { storefrontEmbedQueryOptions } from "@/api/super-admin/use-super-admin-storefront-embed";
import type { StorefrontEmbedAuditDto } from "@babackapp/private-api-client/generated/schema";
import { useQueries } from "@tanstack/react-query";
import { useEffect, useState } from "react";

const MAX_IN_FLIGHT = 5;

// Sliding window: each audit costs two Shopify calls, so hundreds of shops must
// not all be requested at once when the tab opens.
export function useStorefrontEmbedAudits(shopIds: string[]) {
  const [settledCount, setSettledCount] = useState(0);

  const results = useQueries({
    queries: shopIds.map((shopId, index) =>
      storefrontEmbedQueryOptions(shopId, index < settledCount + MAX_IN_FLIGHT),
    ),
  });

  const nextSettledCount = results.filter(
    (result) => result.status !== "pending",
  ).length;
  useEffect(() => {
    setSettledCount(nextSettledCount);
  }, [nextSettledCount]);

  const audits = new Map<string, StorefrontEmbedAuditDto>();
  const failedIds = new Set<string>();
  results.forEach((result, index) => {
    const shopId = shopIds[index];
    if (shopId === undefined) return;
    if (result.data) audits.set(shopId, result.data);
    else if (result.status === "error") failedIds.add(shopId);
  });

  return { audits, failedIds, settledCount: nextSettledCount };
}
